const config = {
    state: {
        windowW: 0
    },
    mutations: {
        SET_WINDOWW(state, payload) {
            // console.log(payload)
            state.windowW = payload
            localStorage.setItem('windowW', payload)
        },
        GET_WINDOWW(state) {
            state.windowW = localStorage.setItem('windowW') || ''
        },
    },
    actions: {
        windowWStorage({ commit }) {
            commit('GET_WINDOWW')
        },
    }
}
export default config